import { useState, useEffect, useRef } from "react";
import {
  Play,
  Rocket,
  Target,
  Users,
  TrendingUp,
  Zap,
  Code,
  MessageCircle,
} from "lucide-react";

import { plans } from "../data/pricing";
import Seo from "../components/Seo";

const images = [
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1779448977/series_ztbi1b.jpg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929986/postermv3_wwfjw6.webp",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929986/postermv21_qpf8ci.webp",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929986/postermv6_bueldt.webp",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929986/postermv21_1_fxaxbz.webp",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929986/postermv4_viepkb.webp",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1779448977/image_live_ctee7m.jpg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1779448977/on-demand-entertainment_xk80hm.jpg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1779448977/sports-streaming_hmiewg.jpg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1780942106/movie-poster-q_cyt6zb.webp",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1780942114/movie-poster-3_kmepck.webp",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1780942124/5DM2wMt9nZUDnbE0zuGt2joigYd.yjBaa4fY_ZVnC9f_g7hbe9.webp",
];

const imagesh = [
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1779705752/IPTV1_po1clb.png",
];

const coupimg = [
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1783366434/2026_FIFA_World_Cup_emblem.svg_a5wv3q.webp",
];

const imagecanel = [
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782926890/netfli_wgnumv.svg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929870/rmc_iog0gi.svg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929870/pluto_mm0nk0.svg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782926890/hbomax_v8s6zi.svg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782926889/disn_lcjtsx.svg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782926888/w9_ephvli.svg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782926890/bein_r1st7d.png",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782926888/OCS_qjmbg9.svg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782926889/svgexport-1_ymdsrm.png",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782926888/tf1_akxbct.png",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929755/canalpluss_ygxv0p.svg",
  "https://res.cloudinary.com/daopsqlfw/image/upload/v1782929755/dzn_qp5dp6.png",
];

function Home() {
  const [openIndex, setOpenIndex] = useState(null);

  const heroRef = useRef(null);
  const containerRef = useRef(null);
  const cannelRef = useRef(null);
  const scrollRef = useRef(null);

  

  // =========================
  // AUTO SCROLL
  // =========================
  const useAutoScroll = (ref, speed = 1) => {
    useEffect(() => {
      const interval = setInterval(() => {
        if (ref.current) {
          ref.current.scrollLeft += speed;

          if (
            ref.current.scrollLeft >=
            ref.current.scrollWidth - ref.current.clientWidth
          ) {
            ref.current.scrollLeft = 10;
          }
        }
      }, 10);

      return () => clearInterval(interval);
    }, [ref, speed]);
  };

  useAutoScroll(heroRef);
  useAutoScroll(cannelRef);
  useAutoScroll(scrollRef);

  // =========================
  // SEO SCHEMA
  // =========================
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "SERVICE IPTV France | 2026 Meilleur Service IPTV avec Essai Gratuit 24h",
    description:
      "Service IPTV Premium en France avec 10,000+ chaînes TV en direct et 120,000+ films/séries",
    url: "https://servicetv.fr",
    applicationCategory: "StreamingService",
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "EUR",
      lowestPrice: "9.99",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "1250",
    },
  };

  return (
    <>
      <Seo
        title="🇫🇷 Abonnement IPTV France 2026 - Essai Gratuit 24h"
        description="Fournisseur IPTV #1 en France. SERVICE IPTV offre 10,000+ chaînes HD/4K, 120,000+ films/séries, streaming sans buffering. Support 24/7 en français. Essai gratuit 24h. Inscription rapide."
        url="https://servicetv.fr"
        image="https://res.cloudinary.com/daopsqlfw/image/upload/v1779705752/IPTV1_po1clb.png"
        schemaMarkup={schemaMarkup}
      />

      <main className="min-h-screen overflow-x-hidden bg-white text-slate-900">

        {/* =====================================================
            HERO
        ====================================================== */}
        <section className="relative flex min-h-screen items-center overflow-hidden bg-gradient-to-br from-white via-blue-50/40 to-red-50/30 px-4 py-24 sm:px-6 lg:px-8">

          {/* Background effects */}
          <div className="pointer-events-none absolute -left-32 top-20 h-80 w-80 rounded-full bg-blue-500/20 blur-3xl" />
          <div className="pointer-events-none absolute -right-32 bottom-10 h-96 w-96 rounded-full bg-red-500/20 blur-3xl" />
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-400/10 blur-3xl" />

          <div className="relative z-10 mx-auto w-full max-w-7xl">

            <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">

              {/* HERO CONTENT */}
              <div className="text-center lg:text-left">

                <div className="mb-5 inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 shadow-sm">
                  <span className="mr-2 h-2 w-2 animate-pulse rounded-full bg-green-500" />
                  SERVICE IPTV Premium
                </div>

                <h1 className="text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                  Regardez{" "}
                  <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-red-600 bg-clip-text text-transparent">
                    vos émissions préférées
                  </span>
                </h1>

                <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg lg:mx-0">
                  Accédez à 25000+ chaînes IPTV sur tous vos appareils.
                  Films, séries, sports - qualité 4K sans interruption.
                  Support 24/7.
                </p>

                {/* Buttons */}
                <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:justify-center lg:justify-start">

                  <button
                    onClick={() =>
                      window.open("https://servicetv.fr/pricing")
                    }
                    className="group inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-red-600 px-6 py-3.5 font-bold text-white shadow-lg shadow-blue-500/25 transition-all duration-300 hover:-translate-y-1 hover:scale-[1.02] hover:shadow-xl"
                  >
                    <Play
                      size={20}
                      fill="currentColor"
                      className="transition-transform group-hover:scale-110"
                    />
                    Commencer à regarder
                  </button>

                  <button
                    onClick={() =>
                      window.open("https://wa.me/447308508638")
                    }
                    className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-blue-600 bg-white px-6 py-3.5 font-bold text-blue-600 transition-all duration-300 hover:-translate-y-1 hover:border-red-600 hover:bg-gradient-to-r hover:from-blue-600 hover:to-red-600 hover:text-white"
                  >
                    <MessageCircle size={20} />
                    Contacter via WhatsApp
                  </button>

                </div>

                {/* Stats */}
                <div className="mt-10 grid grid-cols-1 divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white/70 p-4 shadow-lg backdrop-blur-md sm:grid-cols-3 sm:divide-x sm:divide-y-0">

                  <div className="px-4 py-3 text-center">
                    <div className="text-2xl font-extrabold text-blue-600">
                      5000+
                    </div>
                    <div className="mt-1 text-xs font-medium text-slate-500 sm:text-sm">
                      Chaînes en direct
                    </div>
                  </div>

                  <div className="px-4 py-3 text-center">
                    <div className="text-2xl font-extrabold text-red-600">
                      4K Ultra HD
                    </div>
                    <div className="mt-1 text-xs font-medium text-slate-500 sm:text-sm">
                      Qualité maximale
                    </div>
                  </div>

                  <div className="px-4 py-3 text-center">
                    <div className="text-2xl font-extrabold text-blue-600">
                      24/7
                    </div>
                    <div className="mt-1 text-xs font-medium text-slate-500 sm:text-sm">
                      Support en direct
                    </div>
                  </div>

                </div>
              </div>

              {/* HERO IMAGE */}
              <div
                ref={containerRef}
                className="relative flex items-center justify-center"
              >
                <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-blue-500/20 to-red-500/20 blur-2xl" />

                <div className="relative overflow-hidden rounded-3xl border border-white/50 bg-white/50 p-3 shadow-2xl backdrop-blur-xl">
                  {imagesh.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      loading="lazy"
                      alt={`SERVICE IPTV ${index + 1}`}
                      className="h-auto w-full rounded-2xl object-cover"
                    />
                  ))}
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* =====================================================
            CHANNEL LOGOS AUTO SCROLL
        ====================================================== */}
        <section className="overflow-hidden border-y border-slate-200 bg-slate-50 py-6">

          <div
            ref={cannelRef}
            className="w-full overflow-hidden whitespace-nowrap"
          >
            <div className="flex w-max items-center">

              {[
                ...imagecanel,
                ...imagecanel,
              ].map((img, i) => (
                <div
                  key={i}
                  className="mx-4 flex h-16 w-24 shrink-0 items-center justify-center rounded-xl bg-white p-2 shadow-sm sm:mx-6 sm:h-20 sm:w-28"
                >
                  <img
                    src={img}
                    alt=""
                    loading="lazy"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              ))}

            </div>
          </div>
        </section>

        {/* =====================================================
            MOVIES AUTO SCROLL
        ====================================================== */}
        <section className="overflow-hidden bg-white py-12 sm:py-16">

          <div className="mx-auto max-w-7xl px-4 sm:px-6">

            <h2 className="mx-auto max-w-4xl text-center text-2xl font-extrabold leading-tight text-slate-900 sm:text-3xl lg:text-4xl">
              Films, séries, sports et ligues en illimité avec un seul code IPTV.
            </h2>

            <div
              ref={scrollRef}
              className="mt-10 w-full overflow-hidden"
            >
              <div className="flex w-max">

                {[
                  ...images,
                  ...images,
                ].map((img, i) => (
                  <div
                    key={i}
                    className="mx-2 w-[160px] shrink-0 overflow-hidden rounded-2xl shadow-lg transition-transform duration-300 hover:-translate-y-2 hover:scale-105 sm:w-[200px]"
                  >
                    <img
                      src={img}
                      alt=""
                      loading="lazy"
                      className="h-[240px] w-full object-cover sm:h-[300px]"
                    />
                  </div>
                ))}

              </div>
            </div>

          </div>
        </section>

        {/* =====================================================
            MAIN SECTION
        ====================================================== */}
        <section
          id="develop"
          className="bg-slate-50 px-4 py-16 sm:px-6 lg:px-8"
        >

          <div className="mx-auto max-w-7xl">

            {/* =================================================
                WORLD CUP
            ================================================== */}
            <div className="relative mb-16 overflow-hidden rounded-3xl bg-gradient-to-r from-red-600 to-red-500 p-6 text-white shadow-2xl sm:p-10 lg:p-12">

              <div className="absolute -right-20 -top-20 h-60 w-60 rounded-full bg-white/10 blur-3xl" />

              <div className="relative z-10 grid items-center gap-8 lg:grid-cols-[1fr_auto]">

                <div>
                  <h2 className="text-2xl font-extrabold leading-tight sm:text-3xl lg:text-4xl">
                    Regardez la Coupe du Monde 2026 avec votre{" "}
                    <span className="text-yellow-300">
                      Appareils
                    </span>
                  </h2>

                  <p className="mt-5 max-w-3xl text-sm leading-7 text-white/90 sm:text-base">
                    Un seul abonnement pour tous vos appareils. SERVICE IPTV
                    fonctionne parfaitement sur votre téléphone, tablette,
                    Smart TV, ordinateur et bien d'autres. Commencez sur un
                    appareil et continuez sur un autre, sans interruption.
                  </p>
                </div>

                <div className="flex justify-center">
                  {coupimg.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt="Coupe du Monde 2026"
                      className="h-40 w-40 object-contain drop-shadow-2xl sm:h-52 sm:w-52"
                    />
                  ))}
                </div>

              </div>
            </div>

            {/* =================================================
                PRICING
            ================================================== */}
            <section className="py-4">

              <div className="text-center">
                <h2 className="text-3xl font-extrabold text-slate-900 sm:text-4xl">
                  Plans simples et transparents
                </h2>

                <p className="mt-3 text-base text-slate-600 sm:text-lg">
                  Pas de frais cachés, annulez quand vous voulez
                </p>
              </div>

              <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">

                {plans.map((plan, index) => (
                  <div
                    key={index}
                    className={`relative flex flex-col rounded-3xl border p-6 shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl ${
                      plan.highlighted
                        ? "border-blue-500 bg-[#01183a] text-white shadow-blue-500/20"
                        : "border-orange-400 bg-white text-slate-900"
                    }`}
                  >

                    {/* Badge */}
                    {plan.highlighted && (
                      <div className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gradient-to-r from-blue-600 to-red-600 px-5 py-1.5 text-xs font-bold text-white shadow-lg">
                        Populaire
                      </div>
                    )}

                    <h3
                      className={`text-xl font-extrabold ${
                        plan.highlighted
                          ? "text-white"
                          : "text-slate-900"
                      }`}
                    >
                      {plan.name}
                    </h3>

                    <h4 className="mt-2 text-sm font-bold text-green-500">
                      {plan.app}
                    </h4>

                    <div
                      className={`mt-5 text-4xl font-extrabold ${
                        plan.highlighted
                          ? "text-red-400"
                          : "text-slate-900"
                      }`}
                    >
                      {plan.price}€
                    </div>

                    <ul className="mt-7 flex-1 space-y-4">

                      {plan.features.map((feature, idx) => (
                        <li
                          key={idx}
                          className={`flex items-start gap-3 text-sm leading-6 ${
                            plan.highlighted
                              ? "text-slate-200"
                              : "text-slate-600"
                          }`}
                        >
                          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100 text-xs font-bold text-green-600">
                            ✓
                          </span>

                          <span>{feature}</span>
                        </li>
                      ))}

                    </ul>

                    <button
                      onClick={() =>
                        window.open("https://wa.me/447308508638")
                      }
                      className={`mt-8 w-full rounded-xl border-2 px-5 py-3 font-bold transition-all duration-300 ${
                        plan.highlighted
                          ? "border-blue-400 bg-white text-blue-700 hover:bg-blue-600 hover:text-white"
                          : "border-blue-600 bg-transparent text-blue-600 hover:border-orange-500 hover:bg-orange-500 hover:text-white"
                      }`}
                    >
                      Choisir ce plan
                    </button>

                  </div>
                ))}

              </div>
            </section>

            {/* =================================================
                OBJECTIVES
            ================================================== */}
            <section className="mt-20">

              <div className="text-center">
                <h3 className="text-2xl font-extrabold text-slate-900 sm:text-3xl lg:text-4xl">
                  Découvrez le Meilleur Fournisseur IPTV en France
                </h3>
              </div>

              <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">

                {/* CARD 1 */}
                <div className="group rounded-3xl border border-blue-100 bg-gradient-to-br from-white to-blue-50 p-7 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                  <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-red-500 text-white shadow-lg">
                    <Target size={30} />
                  </div>

                  <h4 className="text-xl font-bold text-slate-900">
                    Service IPTV Premium en France
                  </h4>

                  <p className="mt-3 text-sm leading-7 text-slate-600">
                    Profitez du meilleur service IPTV en France avec une
                    qualité de streaming cristalline, de la SD au 4K Ultra
                    HD. Zéro buffering sur tous les appareils pour une
                    expérience de visionnage inégalée.
                  </p>
                </div>

                {/* CARD 2 */}
                <div className="group rounded-3xl border border-blue-100 bg-gradient-to-br from-white to-blue-50 p-7 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                  <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-red-500 text-white shadow-lg">
                    <TrendingUp size={30} />
                  </div>

                  <h4 className="text-xl font-bold text-slate-900">
                    Films & Séries IPTV Illimités
                  </h4>

                  <p className="mt-3 text-sm leading-7 text-slate-600">
                    Accédez instantanément à plus de 120 000 films et séries.
                    Des dernières sorties aux classiques incontournables, tout
                    est disponible à la demande, sans attente.
                  </p>
                </div>

                {/* CARD 3 */}
                <div className="group rounded-3xl border border-blue-100 bg-gradient-to-br from-white to-blue-50 p-7 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                  <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-red-500 text-white shadow-lg">
                    <Rocket size={30} />
                  </div>

                  <h4 className="text-xl font-bold text-slate-900">
                    Chaînes IPTV en Direct en France
                  </h4>

                  <p className="mt-3 text-sm leading-7 text-slate-600">
                    Diffusez plus de 25 000 chaînes en direct depuis la France
                    et le monde entier. Sport, actualités, divertissement, avec
                    guide TV complet et fonction catch-up TV pour une flexibilité
                    maximale.
                  </p>
                </div>

                {/* CARD 4 */}
                <div className="group rounded-3xl border border-blue-100 bg-gradient-to-br from-white to-blue-50 p-7 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                  <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-red-500 text-white shadow-lg">
                    <Code size={30} />
                  </div>

                  <h4 className="text-xl font-bold text-slate-900">
                    Sport en Direct IPTV France
                  </h4>

                  <p className="mt-3 text-sm leading-7 text-slate-600">
                    Ne manquez plus aucun match grâce à une couverture sportive
                    complète. Ligue 1, Ligue des Champions, Top 14, football,
                    rugby, basketball et bien plus, en direct et en HD.
                  </p>
                </div>

                {/* CARD 5 */}
                <div className="group rounded-3xl border border-blue-100 bg-gradient-to-br from-white to-blue-50 p-7 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                  <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-red-500 text-white shadow-lg">
                    <Users size={30} />
                  </div>

                  <h4 className="text-xl font-bold text-slate-900">
                    Support Premium
                  </h4>

                  <p className="mt-3 text-sm leading-7 text-slate-600">
                    Un support client 24/7 disponible en français et dans 10
                    langues.
                  </p>
                </div>

                {/* CARD 6 */}
                <div className="group rounded-3xl border border-blue-100 bg-gradient-to-br from-white to-blue-50 p-7 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                  <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-red-500 text-white shadow-lg">
                    <Zap size={30} />
                  </div>

                  <h4 className="text-xl font-bold text-slate-900">
                    Contenu Exclusif
                  </h4>

                  <p className="mt-3 text-sm leading-7 text-slate-600">
                    100+ heures de contenu original par an.
                  </p>
                </div>

              </div>
            </section>

            {/* =================================================
                FAQ
            ================================================== */}
            <section className="mt-20">

              <div className="text-center">
                <h3 className="text-2xl font-extrabold text-slate-900 sm:text-3xl">
                  Questions Fréquentes (FAQ)
                </h3>
              </div>

              
            </section>

            {/* =================================================
                HELP BOX
            ================================================== */}
            <section className="mt-12">

              <div className="relative overflow-hidden rounded-3xl border border-blue-200 bg-gradient-to-r from-blue-600 to-red-600 p-8 text-center text-white shadow-2xl sm:p-10">

                <div className="absolute -left-20 -top-20 h-60 w-60 rounded-full bg-white/10 blur-3xl" />
                <div className="absolute -bottom-20 -right-20 h-60 w-60 rounded-full bg-white/10 blur-3xl" />

                <div className="relative z-10">

                  <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white/20 backdrop-blur-md">
                    <MessageCircle size={28} />
                  </div>

                  <h4 className="mt-5 text-2xl font-extrabold">
                    Besoin d'aide ?
                  </h4>

                  <p className="mx-auto mt-3 max-w-xl text-sm text-white/90 sm:text-base">
                    Notre équipe est disponible 24/7 pour répondre à vos
                    questions.
                  </p>

                  <button
                    onClick={() =>
                      window.open("https://wa.me/447308508638")
                    }
                    className="mt-6 inline-flex items-center justify-center gap-2 rounded-xl bg-white px-7 py-3.5 font-bold text-blue-700 shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-slate-100"
                  >
                    <MessageCircle size={20} />
                    Contactez-nous
                  </button>

                </div>
              </div>

            </section>

          </div>
        </section>

      </main>
    </>
  );
}

export default Home;
